export const getQuery = query => {
  const params = query.replace(/[\?\/]/, '').split('&');

  return params.reduce((acc, v) => {
    const [key, value] = v.split('=');
    return { ...acc, [key]: value };
  }, {});
};
